import { Box } from "@chakra-ui/react";

import { paginationEndStyle } from "./style";
import { TPaginationEnd } from "./types";

const PaginationEnd = ({
  startRange,
  endRange,
  count,
  isEndDisabled = false,
}: TPaginationEnd) => {
  return (
    <Box css={paginationEndStyle}>
      {`Showing ${startRange} - ${endRange} of `}
      <span className={isEndDisabled ? "opacity-60" : ""}>{count}</span>
    </Box>
  );
};

export default PaginationEnd;
